// What's on (Stuart, 29 Oct): the hub's first tab — fixtures, training and
// events in ONE upcoming list, grouped by day, so "what have we got this
// weekend?" is one screen instead of three tabs. Pure helpers; the list
// itself is the hub's ordinary GET /events (no type), soonest first.

const KIND = { match: 'Fixture', training: 'Training' };

// The small label on each card: Fixture / Training / Event (everything
// that isn't a match or training is an Event, as in the hub's Events tab).
export const kindLabel = (eventType) => KIND[eventType] || 'Event';

const dayKey = (d) => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;

// "Today", "Tomorrow", then "Sat 1 Nov" — with the year when it isn't this
// year's. Local time, like every other date on the hub.
export const dayLabel = (date, now = new Date()) => {
  const d = new Date(date);
  if (dayKey(d) === dayKey(now)) return 'Today';
  const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  if (dayKey(d) === dayKey(tomorrow)) return 'Tomorrow';
  const opts = { weekday: 'short', day: 'numeric', month: 'short' };
  if (d.getFullYear() !== now.getFullYear()) opts.year = 'numeric';
  return d.toLocaleDateString('en-GB', opts).replace(/,/g, '');
};

// [{ key, label, items }] in time order. Items keep the order they came in
// within a day, after a stable sort on starts_at (the server already sorts,
// but a merged or cached list shouldn't be trusted to).
export const groupByDay = (events, now = new Date()) => {
  const sorted = [...(events || [])]
    .filter(ev => ev && ev.starts_at)
    .map((ev, i) => ({ ev, i, t: new Date(ev.starts_at).getTime() }))
    .filter(x => !Number.isNaN(x.t))
    .sort((a, b) => a.t - b.t || a.i - b.i);
  const days = [];
  for (const { ev, t } of sorted) {
    const d = new Date(t);
    const key = dayKey(d);
    const last = days[days.length - 1];
    if (last && last.key === key) last.items.push(ev);
    else days.push({ key, label: dayLabel(d, now), items: [ev] });
  }
  return days;
};
